import { ALL_MOTIVATIONS } from './constants';

export function validateMotivation(motivation) {
  if (!ALL_MOTIVATIONS.includes(motivation)) {
    throw new Error(`Invalid motivation (${motivation}), must be one of ${ALL_MOTIVATIONS.join(', ')}`);
  }
}

export function createAnnotationBodyString(body = []) {
  if (typeof body === 'string') {
    return body;
  }

  if (Array.isArray(body)) {
    return JSON.stringify(body);
  }

  return JSON.stringify([body]);
}

export function validateBodyString(bodyString) {
  let parsedBody;
  try {
    parsedBody = JSON.parse(bodyString);
  } catch (error) {
    throw new Error(`Invalid annnotation body - expecting json format, received ${bodyString}`);
  }

  if (!Array.isArray(parsedBody)) {
    throw new Error(`Invalid annnotation body - expecting an array of annotation body objects, received ${bodyString}`);
  }
  parsedBody.forEach((bodyObject) => {
    if (typeof bodyObject !== 'object') {
      throw new Error(`Invalid annnotation body - expecting an array of annotation body objects, received ${bodyString}`);
    }
    if (!ALL_MOTIVATIONS.includes(bodyObject.purpose)) {
      throw new Error(`Invalid annnotation body - expecting a purpose that matches one of; ${ALL_MOTIVATIONS.join(', ')}`);
    }
  });
}

export function createAnnotationTargetString(target, subTarget) {
  // clone to ensure we dont modify params, and target is correct type.
  const arrayTarget = Array.isArray(target)
    ? target.map((t) => ({ ...t }))
    : [{ ...target }];

  // make expected modifications...
  if (subTarget) {
    arrayTarget[0].subTarget = subTarget;
  }
  delete arrayTarget[0].ancestry;

  return JSON.stringify(arrayTarget);
}

export function clientAnnotationToMercuryAnnotation({ target, body, ...rest }) {
  return {
    ...rest,
    target: createAnnotationTargetString(target),
    body: createAnnotationBodyString(body),
  };
}

export async function mercuryAnnotationToClientAnnotation({
  target: mercuryTarget,
  body,
  bodyJson,
  targetJson,
  ...restMercuryAnnotation
}, ancestry) {
  const target = JSON.parse(mercuryTarget);
  target[0].ancestry = ancestry;

  return {
    ...restMercuryAnnotation,
    body: JSON.parse(body),
    target,
  };
}
